export default {
  generic: {
    productCode: 'Product code', // 产品编码
    productDetail: 'Product details', // 产品详情
    pixel: 'Pixel', // 像素
    productSize: 'Product size', // 产品尺码
    size: 'Size', // 尺码
    chName: 'Chinese name', // 中文名称
    enName: 'English name', // 英文名称
    productionTechnolegy: 'Production technology', // 生产工艺
    productMaterial: 'Product material', // 产品材质
    material: 'Material', // 材质
    viewMore: 'View more', // 查看更多
    more: 'More', // 更多
    exit: 'Exit', // 退出
    workbench: 'Workbench', // 工作台
    myGallery: 'My gallery', // 我的图库
    goodsLibrary: 'Goods library', // 选品库
    productLibrary: 'Product library', // 产品库
    orderAdmin: 'Order admin', // 订单管理
    cart: 'Cart', // 购物车
    accountInformation: 'Account information', // 账户信息
    warning: 'Warning', // 温馨提示
    yes: 'Yes', // 确定
    cancel: 'Cancel', // 取消
    deleteConfirm: 'Are you sure to delete?', // 确认是否要删除
    search: 'Search', // 搜索
    reset: 'Reset', // 重置
    color: 'Color', // 颜色
    copy: 'Copy', // 复制
    hide: 'Hide', // 隐藏
    delete: 'Delete', // 删除
    addToCart: 'Add to cart', // 添加到购物车
    enterContent: 'Please enter the content', // 请输入内容
    all: 'All', // 所有
    unpaid: 'Unpaid', // 待付款
    needApproval: 'Awaiting Production', // 待审核
    inProduction: 'In Production', // 生产中
    shipped: 'Shipped', // 已发货
    store: 'Store', // 店铺
    orderID: 'Order ID', // 订单ID
    address: 'Address', // 地址
    total: 'Total', // 总计
    products: 'Products', // 产品
    quantity: 'Quantity', // 数量
    item: 'Item', // 项
    edit: 'Edit', // 编辑
    reorder: 'Reorder' // 复制订单
  },
  homepage: {
    allProducts: 'All products', // 所有产品
    bestSeller: 'Best seller', // 畅销产品
    newArraivals: 'New arrivals', // 新到产品
    premiumProducts: 'Premium products', // 优质产品
    economicalProducts: 'Economical products' // 实惠产品
  },
  main: {
    welcome: 'Welcome', // 欢迎
    storeSetupChecklist: 'Store setup checklist', // 商店设置清单
    stepsCompleted: 'steps are completed', // 步骤已完成
    step1: 'Create a Printify account', // 创建Printify帐户
    step2: 'Design your first product', // 设计您的第一个产品
    step3: 'Make a sample order', // 订购样品
    step4: 'Connect your store and start selling', // 连接您的商店并开始销售
    step5: 'Publish 1 product to your store', // 向您的商店发布1个产品
    trendingProducts: 'Trending products', // 热门产品
    tips: 'Tips from Printdoors', // 教程文档
    seeMore: 'See more', // 查看更多
    mainMenu: 'Main Menu', // 主菜单
    order: 'Order', // 订单
    designs: 'Designs', // 设计
    stores: 'Stores', // 店铺
    billing: 'Billing', // 账单
    affiliateProgram: 'Affiliate Program', // 联盟计划
    homepage: 'Home Page', // 首页
    product: 'Product', // 选品
    coupon: 'Coupon' // 优惠券
  },
  login: {
    forgetMessage:
      "Enter your email, and we'll send you a password reset link. This may take a few minutes! If you don't received the email, please check your spam. E-mail", // 忘记密码标题提示
    fullname: 'Fullname', // 用户名
    email: 'E-mail', // 邮箱
    password: 'Password', // 密码
    passwordConfirm: 'Password Confirmation', // 确认密码
    verificationCode: 'Verification Code', // 验证码

    fullnameRule: 'Please enter fullname', // 用户名规则
    emailRule: 'Please enter a valid email', // email验证规则提示
    passwordRule: 'Please enter password', // 密码规则
    passwordConfirmRule: 'Please enter password confirmation', // 确认密码规则
    verificationCodeRule: 'Please enter verification code', // 验证码规则
    login: 'Sign in', // 登录按钮
    register: 'Sign up', // 注册按钮
    forget: 'Forget password', // 忘记密码
    send: 'Sent', // 发送按钮
    vCode_modal: {
      title: 'Verify Your Email',
      content_before:
        'There is the last step to complete registration. For account security, please enter the verification code in ',
      content_after: "we sent to you. If you don't see it, please check your spam folder."
    }
  },
  design: {
    saveProduct: 'Save product', // 保存产品
    revoke: 'Revoke', // 撤销
    recovery: 'Recovery', // 恢复
    clear: 'Clear', // 清空
    productHover: 'Click the product name to view the product details and switch the product color', // 产品名称鼠标悬停提示
    fullScreen: 'Full screen', // 全屏
    shortcutKey: 'Shortcut key', // 快捷键
    designRecord: 'Design record', // 设计记录
    recentlyDesignedProducts: 'Recently designed products', // 最近设计的产品
    generalOperation: 'General operation', // 常规操作
    hotkeysPlaceholder: 'Please press the keyboard to set it', // 请按键盘进行设詈
    restoreInitialKey: 'Restore initial key', // 恢复初始按键
    customizeShortcutKeys: 'Customize shortcut keys', // 自定义快捷键
    cancelSetting: 'Cancel setting', // 取消设置
    saveSetting: 'Save setting', // 保存设置
    restoreKeyWarning: 'Are you sure to restore the default shortcut key?', // 您确定恢复默认快捷键吗？
    saveShortcutKeys_before: 'Shortcut key conflicts with "save (', // 快捷键与“保存(
    saveShortcutKeys_after: ')", please reset', // )”存在冲突，请重新设置
    copySuccessful: 'Copy successful', // 复制成功
    notAllowCopy: 'This browser does not support automatic replication', // 该浏览器不支持自动复制
    customColors: 'Custom colors',
    customColorsTips: 'Add up to 30 custom colors; Right click the color to delete',
    product: 'Product', // 产品
    gallery: 'Gallery', // 图库
    text: 'Text', // 文字
    background: 'Background', // 背景
    layer: 'Layer', // 图层
    designOrNot: 'Design', // 是否设计
    designed: 'Designed', // 已设计
    notDesigned: 'Not designed', // 未设计
    pictureShape: 'Shape', // 图片形状
    quasiSquare: 'Quasi square', // 似方形
    transverseShape: 'Transverse shape', // 横向形
    verticalShape: 'Vertical shape', // 竖向形
    superTransverseShape: 'Super transverse shape', // 超横形
    superVerticalShape: 'Super vertical shape', // 超竖形
    pictureLabel: 'Label', // 图片标签
    tort: 'Tort', // 侵权
    uploadPicture: 'Upload picture', // 上传图片
    allProducts: 'All products', // 所有商品
    myProducts: 'My Products', // 我的商品
    shareGallery: 'Share gallery', // 共享图库
    addText: '+Add text', // 添加文字
    enterText: 'Enter text', // 输入文字
    fontColor: 'Font color', // 字体颜色
    addToCustomColor: 'Add to custom color', // 添加到自定义颜色
    takeColor: 'Take color', // 取色
    presetColor: 'Preset color', // 预设颜色
    notSupportColor: 'This product does not support setting the background color', // 此产品不支持设置背景颜色
    promotion: 'Promotion', // 促销
    addCartSuccess: 'Successfully added to shopping cart', // 加购成功
    viewNow: 'View now', // 立即查看
    addCartRule: 'At least one item quantity is not 0!', // 至少有一项数量不为0!
    viewRenderings: 'View renderings', // 查看效果图
    colorFinder: 'Color finder', // 取色器
    copyFace: 'Copy face', // 复制面
    copyToAllFaces: 'Copy to all faces', // 复制至全部面
    copyToFace: 'Copy to face', // 复制至面
    heightFill: 'Height fill', // 高度填充
    widthFill: 'Width fill', // 宽度填充
    fill: 'Fill', // 填充
    adapt: 'Adapt', // 适应
    center: 'Center', // 居中
    flipHorizontally: 'Flip horizontally', // 水平翻转
    flipVertically: 'Flip vertically', // 垂直翻转
    rotate: 'Rotate', // 旋转
    cutHead: 'Cut head', // 抠头
    cutPicture: 'Cut picture', // 抠图
    clearly: 'Clearly', // 清晰
    crop: 'Crop', // 裁剪
    image: 'Image', // 图像
    xSpacing: 'X-spacing', // X轴间距
    ySpacing: 'Y-spacing', // Y轴间距
    tile: 'Tile', // 平铺
    style: 'Style', // 风格
    shade: 'Shade', // 遮罩
    moveLayerUp: 'Move layer up', // 图层上移
    moveLayerDown: 'Move layer down', // 图层下移
    deleteLayer: 'Delete layer', // 删除图层
    editElementTips: 'Please select an element to edit' // 请选择元素进行编辑
  },
  order: {
    orders: 'Orders', // 订单
    synOrder: 'Synchronization Orders', // 同步订单
    cancelOrder: 'Cancel order', // 取消订单
    CSVOrderImport: 'CSV order import', // csv 订单导入
    orderInputpPlaceholder: 'Enter order ID or product name', // 请输入订单ID或产品名称
    batchesExportOrderInvoice: 'Export invoices in batches', // 批量导出发票
    batchesExportOrderInvoiceContent: 'Are you sure to export invoices in batches ?', // 你确定批量导出发票
    invoice: 'Invoices', // 导出发票
    invoiceContent: 'Are you sure to export invoices', // 你确定导出发票
    uploadLabels: 'Upload Labels in batch', // 批量上传面单按钮
    modifyLogisticsInBatches: 'Modify logistics in batches' // 批量修改物流
  },
  orderImport: {
    uploadOrderImport: 'Upload  order import', // 订单导入
    importOderWithDesignTemplate: 'Import orders with designs in design template', // 在设计模板中导入带有设计的订单
    uploadFile: 'Upload file', // 上传文件
    related: 'Related', // 相关的
    addFiles: 'Add files', // 添加文件
    fileFormatRule: 'Only .csv files allowd', // 只允许.csv文件
    fileSizeRule: 'Less than 1MB', // 小于1MB
    sampleOrderTemplate: 'Sample order template', // 简单订单模板
    alpha2CountryCode: 'Alpha-2 country code', // Alpha-2国家代码
    introductUseCSV: 'Introduction to use CSV files to import orders with designs in design template' // 介绍如何使用CSV文件导入带有设计模板中的设计的订单
  },
  payment: {
    checkout: 'Checkout', // 结算
    purchase: 'Purchase' // 购买
  },
  orderEdit: {
    orderDetials: 'Order details', // 订单详情
    printdoorsOrder: 'Printdoors Order', // printdoors订单
    orderStatus: 'Order Status', // 订单状态
    orderTime: 'Order Time', // 订单时间
    orderCreated: 'Order Created', // 创建订单
    orderTimeline: 'Order Timeline', // 订单时间线
    orderInformation: 'Order Information', // 订单信息
    paymentMethod: 'Payment Method', // 付款方式
    subtotal: 'Subtotal', // 小计
    coupon: 'Coupon', // 优惠券
    shipping: 'Shipping', // 物流
    tax: 'Tax', // 税
    printdoorsDesign: 'Printdoors design', // printdoors设计
    original: 'Original', // 原产品
    cancelOrderTitle: 'Cancel Order', // 取消订单
    cancelOrderContent: 'Are you sure to cancel order ?', // 您确认要取消订单吗？
    orderEidt: 'Order Eidt', // 编辑订单
    continue: 'Continue', // 继续
    operation: 'Operation' // 操作
  },
  customer: {
    customer: 'Customer', // 客户
    name: 'Name', // 名字
    company: 'Company', // 公司
    address: 'Address', // 地址
    telephone: 'Telephone' // 电话
  },
  billing: {
    billingTitle: 'Billing: Payment', // 账单付款
    billingReport: 'Download report' // 导出文件
  },
  productTemplate: {
    template: 'Template' // 模板
  },
  static: {
    aboutUs: {
      bannerTitle: 'start your pod journey on printdoors',
      whatIsPrintDoors: 'What is PrintDoors',
      whatIsPrintDoorsContentOne:
        'PrintDoors is a direct sales platform of the print-on-demand production. For ten years, we have been providing high-quality custom product production and one-off shipping services to more than 20000 cross-border sellers in China. We have nearly 20,000 square meters of custom factories in China, and exceed 100 partner factories. In addition,we are currently preparing branches in San Francisco and New York!',
      whatIsPrintDoorsContentTwo:
        'As the official POD supplier of CJdropshipping and Printify, we are committed to providing high-quality products and services to support the success of our merchants.',
      whatIsPrintDoorsContentThree:
        "As one of China's most professional POD companies for customization plug-in technology, we have established a deep API docking cooperation with Shopify. The next step will be more efforts to provide global e-commerce sellers with convenient and efficient Print-on-Demand, Warehousing Services, and Fulfillment Drop Shipping.",
      ourFactory: 'Our Factory',
      ourFactoryTextOne: 'Nearly 20,000 square feet of on-demand fulfillment space',
      ourFactoryTextTwo: 'Exceed 500 fulfillment team',
      ourFactoryTextThree: 'Latest printing equipment and technology',
      ourFactoryTextFour: 'Fully automated ERP production management system',
      ourFactoryTextFive: 'Strict quality control',
      ourFactoryTextSix: 'Exceed 1000 products production capacity',
      ourFactoryTextSeven:
        'Whenever you receive the finished final product, a unique personalized print-on-demand product, by your design, we are so happy that we play a role in',
      ourFactoryTextEight:
        'providing solutions to turn your idea into your brand. You dream it, and we print it. It is a platform that brings your ideas to life. ',
      ourFactoryTextNine:
        'We are committed to providing our customers with the best possible print-on-demand service, so we hope you will have a pleasant experience using our platform',
      ourFactoryTextTen:
        "If there's anything we can do to make your experience more convenient or efficient, welcome to contact us, and we will be here to serve",
      ourFactoryTextEleven: 'you the most professional advice and service. ',
      addressDescOne: 'U.S. Warehouse：  6245 Pantano Dr, Sacramento, CA 95824',
      addressDescTwo: 'China Warehouse ：26F, building B3, Fuli center, Fuzhou, Fujian, China',
      thanksDescOne: 'Thank you for visiting our platform and feel free to contact us!',
      thanksDescTwo: 'Best wishes to you',
      startDesign: 'Start Designing'
    },
    aboutUsNext: {
      bannerTitleOne: 'How does PrintDoors Work?',
      bannerTitleTwo: 'A Six-Step Guide on Enjoying the PrintDoors Services',
      bannerBtnText: 'start designing',
      stepTextOne: 'Step 1. Sign Up with PrintDoors and Connect to Your Store',
      stepTextTwo:
        'Sign up with PrintDoors today and connect your store seamlessly. Currently we don’t have API on our platform to Amazon, But there are Shopify, Etsy, WooCommerce, shoplazza, etc.',

      stepTextThree: 'Step 2. Select a Product and Create Your Order',
      stepTextFour:
        'With over 800 different products to choose from, you are sure to find the perfect fit for your brand. You can also customize your products using our online model generators, which consider factors such as service location, production time, and budget.',
      stepText_5: 'Step 3. Receive Your Sample and Publish on Your Store',
      stepText_6:
        'After placing an order, you will receive a sample for inspection. If you are satisfied with the product, you can publish it on your store and start selling right away.',
      stepText_7: 'Step 4. Wait for Customer Orders to Be Directed to PrintDoors',
      stepText_8:
        'All you have to do is advertise your products and wait for customer orders to come in. Once a payment is verified, the order will automatically be directed to PrintDoors.',
      stepText_9: 'Step 5. Automatically Complete Your Orders',
      stepText_10:
        'With Your Brand Your orders will be manufactured at our factories using your brand, as soon as payment is received.',
      stepText_11: 'Step 6. Order Complete',
      stepText_12:
        'Your customers will receive their products, and the order will be marked as already shipped. Trust in PrintDoors to provide a streamlined service that maximizes your profits with minimal effort.'
    },
    serviceDesc: {
      text_1: 'Terms of Service',
      text_2:
        'Please read carefully before using the services offered by PrintDoors.com PrintDoors provides users with an automated Internet-based service to design and sell t-shirts and other custom products. By using PrintDoors and its services in any capacity, you have agreed to the terms and conditions of this Agreement and agree to use the site and service solely as provided in this Agreement. For additional clarification on these Terms of Service, please refer to PrintDoors’s Frequently Asked Questions section.',
      text_3: 'USER AGREEMENT',
      text_4:
        'By violating this User Agreement in any capacity, you are subject to an immediate removal of your campaign(s), possible forfeit of profit(s), and potential suspension or termination of your account. PrintDoors.com provides its website and related services to you (“Seller” or “you”) subject to this User Agreement (the “Agreement”), the Intellectual Property Complaint Policy, the Counter-Notice Policy, the Repeat Intellectual Property Complaint Policy, the Refund Policy, and the Privacy Policy (this Agreement and the foregoing policies collectively referred to as “Terms of Service”). All of the terms and obligations set forth in the foregoing policies are incorporated by reference.',
      text_5: 'Delivery Procedure',
      text_6: `Any time quoted for delivery is an estimate only; provided, however, that PrintDoors shall use commercially reasonable efforts to deliver all merchandise on or before the stated 
      delivery date. No delay in shipment or delivery of any merchandise relieves Seller of their obligations under this Agreement.`,
      text_7: 'Print Variance',
      text_8: `
      Product production is generated from the artwork uploaded by the seller. The estimated positioning of the art work is provided by the seller. Print size and exact location may vary 
based on the product size. Colors are best matched to the artwork provided. PrintDoors may substitute comparable products if stock becomes an issue. Exact print size, location, and 
colors are not guaranteed; and are completely dependent on the artwork uploaded by the seller.`,
      text_9: 'BY CREATING A CAMPAIGN ON THE PrintDoors SITE',
      text_10: `You agree to accept and abide by PrintDoors’s Terms of Service in their entirety.
      With respect to any trademarks, service marks, or copyrights that you have licensed from the owner thereof (the “Licensed Rights”), you agree to comply with any restrictions or conditions imposed on the use of the Licensed Rights.
      
      You agree that you are the owner, or licensee, of all rights associated with any created or uploaded artwork or text, including but not limited to, the trademarks and copyrights that may be associated with said material. If you are not the owner, you agree to provide PrintDoors with evidence of the permission given to you by the owner.
      
      You agree that the description and title of the campaign do not, either in and of themselves or in addition to the text and images featured in the created merchandise, infringe upon the rights of any third party.
      
      You understand and agree that PrintDoors reserves the right to remove any content that may be considered to promote hate, violence, racial intolerance, or the financial exploitation of a crime.
      
      You understand and agree that PrintDoors may, in its sole discretion, release your contact information to a third party that satisfactorily alleges, pursuant to PrintDoors’s Intellectual Property Complaint Policy below, unauthorized use of its intellectual property.
      Upon receipt by PrintDoors of an allegation of infringement that comports with PrintDoors’s Intellectual Property Complaint Policy, in PrintDoors’s sole discretion, your campaign may be subject to immediate cancellation, possible forfeiture of any profits, and suspension or termination of your account with PrintDoors.
      
      You agree not to provide untrue information in your campaign including, but not limited to: the amount of product for sale, the origin of production of the product, or the intended recipient of profits.
      
      You agree not to solicit potential buyers through information posted in your campaign other than the purchase of the primary item(s). This includes raffles, chances to win, and other representations of additional opportunities beyond the sale of the primary item being sold.
      You agree to defend, indemnify, and hold PrintDoors and its affiliates harmless from and against any and all claims, damages, costs, and expenses, including attorneys' fees, arising from or relating to your use of PrintDoors’s site and services, your violation of this Agreement, or your violation of any rights of another.
      
      You agree that PrintDoors is not responsible for any consequential, indirect, or any special damages, including, but not limited to, lost profits, associated with any action taken by PrintDoors pursuant to this Agreement or your use of the PrintDoors service.
      `,
      text_11: 'INTELLECTUAL PROPERTY COMPLAINT POLICY',
      text_12: `PrintDoors keep the rights to sweep any infringement contents related to (but not limit) trade mark, copy rights and other content violation. All the content uploaded by user should go through our review process with 2 steps as below:

      At the first round, our platform will do a check by our bot. Our bot will automatically crawl all the user generated contents and match it with Google Vision library. If it found any content violation, the platform will flag the campaign immediately.
      Some tricky designs should be able to pass the bot. We have our second round of reviewing by human to make sure we can catch those content.
      PrintDoors provides users with a platform to sell their own merchandise. User contractually agree to all terms prior to use of PrintDoors services. PrintDoors contractually prohibit users from using its services to sell merchandise that infringes upon third party intellectual property rights (such as copyright, trademark, trade dress, and right of publicity).
      
      It is PrintDoors policy to block and remove any content that it believes in good faith to infringe the intellectual property rights of third parties following receipt of a compliant notice; and to terminate service for repeated infringement.
      
      If you believe that your intellectual property rights have been infringed upon by a PrintDoors user, please notify PrintDoors at legal@PrintDoors.com. You must include within your notification the following information:
      
      A physical or electronic signature of a person authorized to act on behalf of the owner of the intellectual property that you allege is being infringed
      The URL to the PrintDoors campaign(s) used in connection with the sale of the allegedly infringing merchandise.
      Identification of the copyright, trademark, or other rights that allegedly have been infringed, including proof of ownership (such as copies of existing trademark or copyright registrations).
      Your full name, address, telephone number(s), and email address(es).
      A statement that you have a good-faith belief that use of the material in the URL submitted is unauthorized by the rights owner, or its licensee, and such use amounts to infringement under federal or state law.
      A statement, under penalty of perjury, that the information in the notification is complete and accurate and that you are authorized to act on behalf of the owner of the intellectual property or other right that is allegedly infringed.
      `,
      text_13: 'COUNTER-NOTICE POLICY',
      text_14: `If you believe that a claim of intellectual property infringement was filed by mistake or misidentification you may file a counter-notice. If you materially misrepresent in your counter-notice that your design is not infringing upon the intellectual property, you may be liable for damages to the intellectual property owner (including costs and attorney’s fees). Therefore, if you are unsure whether or not the material infringes on the intellectual property, please contact an attorney before filing the counter-notice. The counter-notice should be submitted to support@PrintDoors.com and must include the following information:

      Your physical or electronic signature;
      Your full name, address, telephone number(s), and email address(es);
      Identification of the material and its location before it was removed, either by URL to the PrintDoors campaign(s) used in connection with the sale of the allegedly infringing merchandise or PrintDoors campaign number;
      A statement under penalty of perjury that the claim of intellectual property infringement that led to the removal or blockage of access to material was filed by mistake or misidentification;
      Your consent to the jurisdiction of a federal court in the district where you live (if you are in the U.S.), or your consent to the jurisdiction of a federal court in the district where your service provider is located (if you are not in the U.S.);
      Your consent to accept service of process from the party who submitted the takedown notice or an agent of that party.
      If you submit a counter-notice, a copy of the counter-notice may be sent to the complaining party informing the complaining party that PrintDoors may replace the removed material or cease disabling it in 10 business days. Unless the intellectual property owner files an action seeking a court order against you, the removed material may be replaced or access to it restored in 10 to 14 business days after receipt of the counter-notice.
      `,
      text_15: 'REPEAT INTELLECTUAL PROPERTY COMPLAINT POLICY',
      text_16: `If PrintDoors receives repeated notices that you have posted others’ intellectual property without permission, PrintDoors may terminate your account. PrintDoors has a system for keeping track of repeat violators of intellectual property rights of others, and determining when to suspend or terminate your account.

      PrintDoors reserves the right to terminate accounts that act against the spirit of the Terms of Service, regardless of how many strikes are involved.
      `,
      text_17: 'WITHHOLDING AND TAX MATTERS',
      text_18: `It is contemplated that the services and transactions described in this Agreement will not impose a withholding obligation upon PrintDoors under Section 1442 of the Internal Revenue 
      Code, as amended (the “Code”). Notwithstanding the foregoing, in the event PrintDoors concludes that it has an obligation to withhold under Section 1442 of the Code (or other 
      applicable law) with respect to Seller Profits, PrintDoors will withhold all applicable income tax from any payments or Seller Profits otherwise due to Seller.
      Seller shall be solely responsible for payment of its own tax liabilities which may arise under the Agreement, and shall indemnify PrintDoors for any tax obligations, including for 
      federal income tax withholding, which may arise as a result of this Agreement.`,
      text_19: 'INDEMNIFICATION',
      text_20: `Seller shall indemnify, defend and hold harmless PrintDoors and PrintDoors’s affiliates, employees, officers, directors, and agents from and against all claims, demands, actions, suits, damages, liabilities, losses, settlements, costs and expenses (including attorneys’ fees) which arise out of or relate to (i) any content submitted or posted by Seller, (ii) Seller’s use of, or connection with, PrintDoors’s website, (iii) Seller’s violation of any of the terms of this Agreement or the Terms of Service, or (iv) Seller’s violation of any rights of a third party. To secure Seller’s prompt and complete payment and performance of any and all present and future indebtedness, obligations and liabilities of Seller to PrintDoors including with respect to any indemnification arising out of the Agreement or the Terms of Service, Seller hereby grants PrintDoors a security interest in all proceeds of the merchandise (including Seller Profits and insurance proceeds). PrintDoors shall be entitled to all applicable rights and remedies of a secured party under applicable law.

      IN NO EVENT SHALL PrintDoors’S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT OR THE TERMS OF SERVICE, WHETHER ARISING OUT OF OR RELATED TO BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE, EXCEED THE AMOUNT OTHERWISE OWED TO SELLER AS SELLER PROFIT.
      `,
      text_21: 'Disclaimer of Warranties',
      text_22: `YOUR USE OF THE PrintDoors SERVICE IS AT YOUR SOLE RISK. THE PrintDoors SERVICE IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. WITHOUT LIMITING A BUYER’S RIGHT TO RETURN MERCHANDISE AND OBTAIN A REFUND TO THE EXTENT DESCRIBED IN OUR RETURN POLICY, PrintDoors EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND WITH RESPECT TO ANY CAMPAIGN, MERCHANDISE OR SERVICE, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.
      `,
      text_23: 'Limitation of Liability',
      text_24: `PrintDoors WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY DAMAGES, OR DAMAGES FOR LOSS OF PROFITS INCLUDING BUT NOT LIMITED TO, 
      DAMAGES FOR LOSS OF GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF PrintDoors HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), WHETHER BASED ON 
      CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, RESULTING FROM: (I) THE USE OR THE INABILITY TO USE THE SERVICE; (II) THE COST OF PROCUREMENT OF SUBSTITUTE 
      GOODS AND SERVICES RESULTING FROM ANY MERCHANDISE, DATA, INFORMATION OR SERVICES PURCHASED OR OBTAINED OR MESSAGES RECEIVED OR TRANSACTIONS ENTERED INTO 
      THROUGH OR FROM THE SERVICE; (III) UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; OR (IV) ANY OTHER MATTER RELATING TO THE SERVICE. IN NO EVENT
      WILL PrintDoors TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES OR CAUSES OF ACTION EXCEED THE AMOUNT YOU HAVE PAID PrintDoors OR PrintDoors HAS PAID YOU IN THE LAST SIX
      (6) MONTHS, OR, IF GREATER, ONE HUNDRED DOLLARS ($100). THE FOREGOING LIMITATIONS WILL APPLY TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW.`,
      text_25: 'Exploiting system vulnerabilities',
      text_26: `PrintDoors preserves the right to deal with individuals and organizations that intentionally exploit system vulnerabilities in order to usurp benefits. Individuals and organizations who 
      have intentionally exploited the system vulnerabilities of PrintDoors are obligated to recover the damage caused. Damage includes, but is not limited to, the categories listed below`,
      text_27: 'Exploiting system vulnerabilities',
      text_28: `PrintDoors preserves the right to deal with individuals and organizations that intentionally exploit system vulnerabilities in order to usurp benefits. Individuals and organizations who 
      have intentionally exploited the system vulnerabilities of PrintDoors are obligated to recover the damage caused. Damage includes, but is not limited to, the categories listed below
      Loss of money and other benefits
      System interruption
      The damage caused by ddos and other forms of attack`,
      text_29: 'MISCELLANEOUS PROVISIONS',
      text_30: `Terms of Agreement Prevail Over Seller’s Campaign Purchase Order
      The parties intend for the express terms and conditions contained in this Agreement (including any schedules and exhibits hereto), and the pricing terms as set forth for each campaign, to exclusively govern and control each of the parties’ respective rights and obligations regarding the subject matter of this Agreement, and this Agreement is expressly limited to such terms and conditions. Any attempt to modify, supersede, supplement or otherwise alter this Agreement, will not modify this Agreement or be binding on the parties unless such terms have been fully approved in a signed writing by both parties`,
      text_31: 'Relationship of the Parties',
      text_32: `Nothing in this Agreement or the Terms of Service creates any agency, joint venture, partnership or other form of joint enterprise, employment or fiduciary relationship between the 
      parties. Neither party has any express or implied right or authority to assume or create any obligations on behalf of or in the name of the other party or to bind the other party to any 
      contract, agreement or undertaking with any third party.`,
      text_33: 'Entire Agreement',
      text_34: `This Agreement (and the Terms of Service) constitute the entire agreement of the parties with respect to the subject matter contained herein, and supersedes all prior and 
      contemporaneous understandings, agreements, representations and warranties, both written and oral, with respect to such subject matter.`,
      text_35: 'Assignment',
      text_36: `Seller may not assign any of its rights or delegate any of its obligations under this Agreement without the prior written consent of PrintDoors. PrintDoors may assign any of its rights or 
      delegate any of its obligations hereunder in PrintDoors’s sole discretion.`,
      text_37: 'Severability',
      text_38: `If any term or provision of this Agreement (or the Terms of Service) is invalid, illegal or unenforceable in any jurisdiction, such invalidity, illegality or unenforceability does not affect any
      other term or provision of this Agreement (or the Terms of Service) or invalidate or render unenforceable such term or provision in any other jurisdiction.`,
      text_39: 'Governing Law; Venue',
      text_40: `This Agreement and the Terms of Service shall be governed by the laws of France,without giving effect to the principles of conflicts of laws. Each party consents to the personal jurisdiction of the Federal, state, or local county courts located in Hillsborough County, France,Each party agrees that any such court shall have in personam jurisdiction over such party and consents to service of process by notice sent to the address set forth above and/or by any means authorized by law.`,
      text_41: 'Waiver of Jury Trial',
      text_42:
        'Each party waives any right it may have to a trial by jury in respect of any legal action arising out of or relating to this Agreement or the Terms of Service.',
      text_43: 'BUYER PAYMENTS, RETURNS, REFUNDS, AND CANCELLATION POLICY',
      text_44:
        'By clicking "Place Your Order" you ("Buyer" or "You") agree that you have read and understood all terms and policies that apply to you in this document.',
      text_45: 'Payment methods',
      text_46:
        'We accept payment including VISA, MASTER, AMERICAN EXPRESS and Paypal. Other type of payments will not be accepted.',
      text_47: 'Time of payment',
      text_48:
        'Due to the extensive amount of work required prior to the printing and shipping of your order (e.g., User Content preparation), Buyers will be charged at the time their order is placed. If you purchase any merchandise through the PrintDoors Service, you will be required to provide PrintDoors information regarding your credit card or other payment instrument. You represent and warrant to PrintDoors that such information is true and that you are authorized to use the payment instrument.',
      text_49: 'Time of Shipment',
      text_50: `For all Products except apparel, we will print your Product shortly after the completion of your order and ship the Product in due course. For Products that are apparel (e.g., t-shirts), all
      Products of the same type will be printed and shipped. Customer(s) can expect to receive their products 14-21 business days after their payment has been received and their order 
     processed. Customer(s) acknowledges and agrees that the stated delivery time frame of 14-21 business days is an estimate, and under certain instances (such as delays caused by the 
     postal service, delays due to weather events or natural disasters) deliveries may exceed the stated time frame.
     International: Certain countries do not provide international tracking once the shipment has left the country that our store located. If Seller experiences a lost or delayed shipment, 
     Seller should ask the 3rd Party Customer to reach out to their local post office to inquire about which carrier UPS connects to in their country. PrintDoors is not responsible for 
     providing a list of the aforementioned countries nor contacting the third-party carrier on the Seller’s or 3rd Party Customer's behalf.`,
      text_51: 'Lost or Stolen Shipments',
      text_52: `PrintDoors does not guarantee domestic and/or international shipments nor handle returns or exchanges. Certain countries are considered "high risk" for issues such as lost or stolen 
      and/or lost-in-transit shipments. Shipping PrintDoors products domestically & internationally are at the sole risk of the Seller. PrintDoors is not liable for shipments that do not deliver
       successfully.`,
      text_53: 'Cancellations, Refunds, & Exchanges',
      text_54: `Due to the customized characteristics of Products, we do not allow cancellations, exchanges, or refunds. If upon delivery of the product you feel that your order was incorrect due to 
      error on our part, such as the wrong color, item size, or design, please email us within fourteen days of your delivery. Claims will be handled on a case basis. You acknowledge and 
      agree that goods produced by us for you are bespoke, custom-made goods. Other than where goods are faulty, you have no right to cancel any order or return any goods and all 
      orders are final.`,
      text_55: 'API (SHOPIFY, WOOCOMERCE,…) POLICY OVERVIEW',
      text_56: `
      be reproduced or used without prior written permission. Seller may not use language that is threatening, abusive, vulgar, discourteous or criminal. Seller also may not post or transmit 
information or materials that would violate the rights of any third party or which contains a virus or other harmful component. PrintDoors reserves the right to remove or edit any 
messages or material submitted by Sellers.
PrintDoors integrates all information, tools, and services through 3rd Party Platforms (i.e. Shopify) to benefit the Seller upon acceptance of all terms, conditions, policies, and notices 
herein. By accessing or using any part of the PrintDoors application and/or purchasing merchandise through PrintDoors, the Seller engages in PrintDoors service and agrees to be bound 
by the following Terms of Service. All of the terms and obligations set forth in the foregoing policies are incorporated by reference. These Terms of Service apply to all Sellers of the 
PrintDoors application, including without limitation: Users who are browsers, PrintDoors, customers, Sellers, and/or contributors of content.
If Seller does not agree to all terms and conditions of this agreement, Seller may not access the application and website, or utilize any PrintDoors services.
Any and all new PrintDoors application features and/or tools added are subject to the current Terms of Service. The most current version of the Terms of Service is available at any time
on this page. PrintDoors reserves the right to update, change or replace any part or part(s) of these Terms of Service by posting updates and/or changes to the company website. 
PrintDoors is not responsible for directly updating any Seller, or “3rd Party Customer” (or “Buyer”), of aforementioned updates. Continued use of, or access to, the PrintDoors 
Application following the posting of any service modifications constitutes acceptance of any updates to the Terms of Service. PrintDoors does not handle and is not responsible for any
Seller services including payment processing, returns, refunds, or exchanges. PrintDoors is not responsible for Sellers customer service. This agreement is effective 
    `,
      text_57: 'API (SHOPIFY, WOOCOMERCE,…) POLICY OVERVIEW',
      text_58: `
      be reproduced or used without prior written permission. Seller may not use language that is threatening, abusive, vulgar, discourteous or criminal. Seller also may not post or transmit 
information or materials that would violate the rights of any third party or which contains a virus or other harmful component. PrintDoors reserves the right to remove or edit any 
messages or material submitted by Sellers.
PrintDoors integrates all information, tools, and services through 3rd Party Platforms (i.e. Shopify) to benefit the Seller upon acceptance of all terms, conditions, policies, and notices 
herein. By accessing or using any part of the PrintDoors application and/or purchasing merchandise through PrintDoors, the Seller engages in PrintDoors service and agrees to be bound 
by the following Terms of Service. All of the terms and obligations set forth in the foregoing policies are incorporated by reference. These Terms of Service apply to all Sellers of the 
PrintDoors application, including without limitation: Users who are browsers, PrintDoors, customers, Sellers, and/or contributors of content.
If Seller does not agree to all terms and conditions of this agreement, Seller may not access the application and website, or utilize any PrintDoors services.
Any and all new PrintDoors application features and/or tools added are subject to the current Terms of Service. The most current version of the Terms of Service is available at any time
on this page. PrintDoors reserves the right to update, change or replace any part or part(s) of these Terms of Service by posting updates and/or changes to the company website. 
PrintDoors is not responsible for directly updating any Seller, or “3rd Party Customer” (or “Buyer”), of aforementioned updates. Continued use of, or access to, the PrintDoors 
Application following the posting of any service modifications constitutes acceptance of any updates to the Terms of Service. PrintDoors does not handle and is not responsible for any
Seller services including payment processing, returns, refunds, or exchanges. PrintDoors is not responsible for Sellers customer service. This agreement is effective 
    `,
      text_59: 'LOST / STOLEN',
      text_60: `PrintDoors does not guarantee domestic and/or international shipments nor handle returns or exchanges. Certain countries are considered "high risk" for issues such as lost or stolen and/or lost-in-transit shipments. Shipping PrintDoors products domestically & internationally are at the sole risk of the Seller. PrintDoors is not liable for shipments that do not deliver successfully.

      International: Certain countries do not provide international tracking once the shipment has left the country that our store located. If Seller experiences a lost or delayed shipment, Seller should ask the 3rd Party Customer to reach out to their local post office to inquire about which carrier UPS connects to in their country. PrintDoors is not responsible for providing a list of the aforementioned countries nor contacting the third-party carrier on the Seller’s or 3rd Party Customer's behalf.
      `,
      text_61: 'PRINTING & PRODUCTION',
      text_62: `PrintDoors prohibits Sellers from using the service to sell merchandise that infringes upon third party intellectual property rights (such as copyright, trademark, trade dress, and right of publicity). Merchandise production is generated from the artwork and mock-up provided by the Seller (3rd Party Platform seller). Print size may vary based on the individual product size. Colors are best matched to the artwork, and PrintDoors may substitute comparable products if stock becomes an issue. Exact print size, location, and colors are not guaranteed. Seller is responsible for checking his/her "Action Required” tab within 3rd Party Platform and it is Seller’s responsibility to take manual action if there is an address or payment issue. It is the sole responsibility of the Seller to rectify the issue manually before PrintDoors can continue with production. PrintDoors is not responsible for orders that are not processed due to these aforementioned issues.

      These Services are operated and provided by PrintDoors. If you have any questions about these Terms, please contact PrintDoors at support@PrintDoors.com.
      
      ADDRESS： 26/F, Prosperity Tower, 39 Queen's Road Central, Central, Hong Kong Print Doors Electronic
      Commerce Co.. Limited.`,
      text_63: 'GOVERNING LAW',
      text_64: 'These Terms of Service and any separate agreements whereby we provide youServices shall be governed by and construed in accordance with the laws of HongKong.'
    },
    serviceDescNext: {
      text_1: 'What is the bulk Order Discount?',
      text_2: `Bulk Order Discount is a pricing system for products ordered in bulk. Order more,discount more`,
      text_2_1: `After placing your mouse over the image, you can see it on our product detail page or product listing page.`,
      text_3: 'Discount',
      text_4: 'NOTE:',
      text_5: `Bulk Order Discount Just For One Order`,
      text_6: `The Same Product May Have Different Designs In One Order`,
      text_7: `The Product Discount Of Bulk Discount Order Is Not Allowed For One Order.Printdoors Will Use The Larger One Price When Checking.
                For Example:If Product A Is Available At A 10% Discount And You Order 11 Pieces. There Is A 5% Volume Discount, Then Printdoors Will Use The Larger 10% Discount To Calculate Payment For Your Order`,
      text_8: `Different Discounts Depend On Different Products,Please Refer To The Actual.`,
      text_9: `Tips:`,
      text_10: `Posting the same product with different designs can help catch your customers' eyes and get to know your niche in a short time.`,
      text_11: 'It will also be impressive when customers visit your store for the first time.',
      text_12: `This is a great opportunity to order different designs in bulk`
    },
    connectUs: {
      text_1: 'Get in touch',
      text_2: `Have any questions? We'd love to hear from you`,
      text_3: 'Email',
      text_4: 'Please feel free to contact us by email.',
      text_5: 'support@printdoors.com',
      text_6: 'Chat live',
      text_7: 'Chat with our support team.',
      text_8: 'Chat Now',
      text_9: 'Contact us',
      text_10: 'Tell us about any suggestions and feedback related to our services.',
      text_11: 'Full Name',
      text_12: 'Email',
      text_13: 'Message',
      text_14: 'Confirm',
      text_15: 'Please input your fullname',
      text_16: 'Please input your email',
      text_17: 'Please input your message'
    },
    privacyPolicy: {
      text_1: 'PRIVACY POLICY',
      text_2: `This privacy policy details how brand collects and uses the personal information our users have provide on our website, PrintDoors.com. It also outlines what the available to you are 
      regarding the use of your submitted personal information, and how you can access and update the said information.`,
      text_3: `COLLECTION AND USE OF PERSONAL INFORMATION`,
      text_4: `Our site collects the following personal information from you:
      Basic user contact Information and identification such as name, email address, mailing address, and phone number.
      Billing Information such as name and billing address
      As is true of most web sites, we gather information about your computer automatically, which includes your IP address, browser type, entrance/exit pages, referring pages, and operating
      We use this information to:
      Fulfill your order
      Send your order confirmation
      Send the product or service information requested
      Send you product updates or information about your warranty
      Respond to customer service requests
      Administer your account
      Respond to your questions and other concerns`,
      text_5: `SPREAD THE WORD`,
      text_6: `If you would like to make use of our email tool to “spread the word” and tell your friend about our site, we will ask you for your friend’s email address. Our system will automatically
      send your friend a one-time email to invite them to visit PrintDoors. `,
      text_7: `FACEBOOK CONNECT OR OPEN ID`,
      text_8: `You can also log in to our website using sign-in services such as Facebook Connect or an Open ID provider. These services will verify and authenticate your identity, which then will give 
      you the choice to share certain personal information with us such as your name and email address to pre-populate our sign up form for faster signups. These services - like Facebook 
      Connect – will give you the option to post information about your activities on this website to your profile page, to share with others within your network.`,
      text_9: `INFORMATION SHARING`,
      text_10: `We may also use cookies for various purposes. We use it, for example, to track your preferences and profile information. We also use it to collect general usage and volume statistical 
      information, but doing so does not include personal information. We also use other companies to place cookies on your computer to collect non-personal information to compile 
      aggregated statistics for us about visitors to our site, to guide us into serving our customers and visitors better.
      We use local shared objects, also known as Flash cookies, to store your preferences such as displaying content based upon what you view on our site to personalize your visit. These 
      third Parties, with whom we partner with to provide features on our site, or to personalize advertising upon your Web browsing activity, use Flash cookies to collect and store your 
      information. These flash cookies are different from browser cookies because of the amount, type, and how your data is stored. Cookie management tools provided by your browser 
      will not remove Flash cookies.`,
      text_11: `COOKIES AND OTHER TRACKING TECHNOLOGIES`,
      text_12: `We may also use cookies for various purposes. We use it, for example, to track your preferences and profile information. We also use it to collect general usage and volume statistical 
      information, but doing so does not include personal information. We also use other companies to place cookies on your computer to collect non-personal information to compile 
      aggregated statistics for us about visitors to our site, to guide us into serving our customers and visitors better.
      We use local shared objects, also known as Flash cookies, to store your preferences such as displaying content based upon what you view on our site to personalize your visit. These 
      third Parties, with whom we partner with to provide features on our site, or to personalize advertising upon your Web browsing activity, use Flash cookies to collect and store your 
      information. These flash cookies are different from browser cookies because of the amount, type, and how your data is stored. Cookie management tools provided by your browser 
      will not remove Flash cookies.`,
      text_13: `BEHAVIORAL TARGETING/RE-TARGETING`,
      text_14: `We partner with third party ad network/s to either display advertising banners and texts on our website or to manage our advertising on other sites our users visit. Our ad network 
      partner uses  cookies and Web beacons to collect non-personally identifiable information about your activities on this and other websites to provide you targeted advertising based 
      upon your interests and web activities. If you wish to not have this information used to serve you targeted ads, you may opt-out by clicking here. Please note this does not opt you 
      out of being served advertising. You will continue to receive generic ads.`,
      text_15: `LINKS TO OTHER WEB SITES`,
      text_16: `Our website includes links to other websites whose privacy practices may be different from ours. If you submit personal information to any of those sites, your information is subject to 
      their respective privacy policies. We encourage you to read through the privacy policy of any Web site you visit thoroughly.`,
      text_17: `DATA RETENTION`,
      text_18: `We will store and retain your provided information as long as your account is active or as needed to provide you services. If you want to cancel your account or to request that we cease 
      using your information to provide you services, please feel free to contact us. We will only retain and use your information as necessary to comply with our legal obligations, resolve 
      disputes, and enforce our agreements.`,
      text_19: `DELETION / DEACTIVATION`,
      text_20: `If you change your personal information, or if you desire to stop getting our service, you are allowed to correct, update, or remove it by changing it on our member information page, 
      ringing us up on our phone numbers, or by dropping us a line through postal mail at the contact information listed below.`,
      text_21: `SECURITY`,
      text_22: `Securing your personal information is important to us. We abide and follow generally-accepted industry standards to protect our users personal information that was submitted and 
      entrusted to us, both during transmission and once we receive it. When you enter sensitive information (such as a credit card number) on our order forms, we automatically encrypt 
      the transmission of the said information using secure socket layer technology (SSL). We also encrypt your information (customer information) in our database so that customers 
      name and address is never stored in plain text. That said, do note that no method of transmission over the Internet, or method of electronic storage, is 100% secure. Therefore, as much 
      as we want to, we cannot guarantee its absolute security. Please feel free to contact us if you have any concerns or other questions about security on our website.
      We provide two ways for you to make purchase on our site: You may opt to use our order form, or make use of a third-party payment option. If you choose to use our shopping cart, the
      transmission of sensitive information collected on our order form is automatically encrypted using secure socket layer technology (SSL) and is processed by Authorize.net. If you choose 
      to use a third party payment option, such as PayPal, to pay, their privacy policies and security practices will apply to your information. To make sure your information is secure, we 
      encourage you to read their respective privacy policies before providing your information.`,
      text_23: `SOCIAL MEDIA FEATURES AND WIDGETS`,
      text_24: `Our Website Includes Social Media Features, Such As The Facebook Like Button And Widgets. These Widgets May Collect Your IP Address, The Page Where You Are Viewing On Our Site, And 
      May Rigger A Cookie For The Feature To Function Properly. These Social Media Features And Widgets Are Hosted Either By A Third Party Or Directly On Our Site. The Interactions Made With 
      These eatures Are Governed By The Privacy Policy Of The Company Providing It.`,
      text_25: `TESTIMONIALS`,
      text_26: `We love our customers and their feedback. To show appreciated, we display testimonials of some of our satisfied customers on our site in addition to other endorsements we gather. 
      With your consent, we may post your testimonial along with your name. If you wish to edit, update, or delete your testimonial, you can contact us at support@PrintDoors.com`,
      text_27: `NOTIFICATION OF PRIVACY POLICY CHANGES`,
      text_28: `We may update this privacy policy to reflect changes to our information practices – its collection and implied usage. If we make any material changes to these policies, we will notify you
      by email (sent to the e-mail address specified in your account), and/or by means of a notice on this site prior to the change becoming effective. We encourage you to review this page 
      periodically for the updates and the latest information on our privacy practices.`,
      text_29: `CONTACT INFORMATION:`,
      text_30: `Email: support@PrintDoors.com`
    },
    affiliateProgram: {
      text_1: 'Printdoors Affiliate Program',
      text_2: 'Become a Printdoors affliate partner and earn 10% from every order',
      text_3: 'made by your referred customers for the following 12 month',
      text_4: 'Become an Affiliate',
      text_5: 'How to Start',
      text_6: 'Register',
      text_7: `Fill Out The Affiliate Application Form On Our Website.`,
      text_8: 'Get Your Approval And',
      text_9: `Unique Link`,
      text_10: 'Wait For Approval From Our Team.',
      text_11: 'Promote',
      text_12: `Receive Your Unique Referral Link And Start Promoting Our Products.`,
      text_13: 'Earn',
      text_14: `Track Your Referrals And Commissions In Real-time Using Our Affiliate Platform.`,
      text_15: `Why become a Printdoors affiliate?`,
      text_16: `No Upfront Costs`,
      text_17: `no monthly fees charge. free to register`,
      text_18: `NO Limit`,
      text_19: `NO minimum and maximum orders limits
      no need for inventory.`,
      text_20: `Win-Win Model`,
      text_21: `One month membership and coupons for
      your referred customers`,
      text_22: `Commissions`,
      text_23: `10%commission of every order made
      from your referred customers for 12
      months.`,
      text_24: `Fast Payouts`,
      text_25: `cash out your earnings with multiple
      payment options in 1~3 working days.`,
      text_26: `Data Dashboard`,
      text_27: `Track how much money you make
      through a custom dashboard built just
      for you.`,
      text_28: `Who Can Join Printdoors Affiliate Program`,
      text_29: `our affilate program are suitable for all kinds of publishers`,
      text_30: `Video
      Creators`,
      text_31: `Bloggers`,
      text_32: `Influeners`,
      text_33: `Ecommerce
      Entrepreneurs`,
      text_34: `More Details`,
      text_35: `Your commission is calculated based on your final payment amount(not the customer's retail price) minus shipping amount`,
      text_36: `ln order for a referral to be connected to your account, they need to sign up to printdoors within 30 days of opening your link`,
      text_37: `an affiliate period lasts 12 months after your referred customer's first order `,
      text_38: `you'll receive commission after an order has received`,
      text_39: `minimum withdrawal sum is $25. payments are made in USD via PayPal in 1~3business days`,
      text_40: `Can't wait to experience the printdoors affiliate program！`,
      text_41: `Apply now >`
    },
    shipping: {
      text_1: `Shipping Policy`,
      text_2: `All items are made-to-order. This means that when you place your order, we print that item just for you, one at a time for the best quality!`,
      text_2_1: `Due to the impact of COVID-19, the production and delivery times have been delayed by up to 10 business days than the time frame below. We truly apologize for this inconvenience`,
      text_2_2: `And Thank you for your understanding and sympathy with us in this situation.`,
      text_2_3: `Wish you and your family all the best.`,
      text_3: `1.How long for shipment?`,
      text_4: `Receiving time = Processing time +Shipping time.`,
      text_4_1: `Orders can be cancelled or modified within 2 hours after being placed`,
      text_4_2: `Estimated time of arrival:`,
      text_5: `·The above time frame is only applied for orders to the US with standard shipping methods.`,
      text_5_1: `·International orders: It may take additional days if orders have to go through customs.`,
      text_5_2: `·Due to the global impact of COVID-19, the processing time will be a bit delayed than usual`,
      text_6: `We Use DHL、USPS、EMS.`,
      text_7: `Note: The shipping time will be affected by public holidays, destination countries (especially shipping addresses outside USA or UK), bad weather and international couriers.`,
      text_8: `2.Where is my order?`,
      text_9: `Your shipping confirmation will be received only when your items are fulfilled. Please fill in your both account email and order number in order to monitor order status.`,
      text_10: `3.Tips for shipping:`,
      text_11: `·1.For delivering successfully, we suggest you leave your correct email box and mobile number during checkout process.`,
      text_11_1: `·2.Unsuccessful delivery caused by blank mobile column cannot be compensated.`,
      text_11_2: `·3.PO Box or BFPO is not accepted if you choose express shipping. Your address should be detailed enough, even include apartment or unit number. Non delivery or extra shipping fee due to personal reasons will not be taken by PrintDoors.`,
      text_11_3: `·4. Your order can be tracked in details only when it arrives in your country's facility. After it arrives in your country, please allow 5-7 days more for the package to reach you.`,
      text_11_4: `·5.If you have any question, please contact our customer service. Since we have too many emails to deal with every day, your email may be replied in 24 hours. Thank you for your patience and understanding!`,
      text_12: `4.Incorrect address`,
      text_13: ` Make sure you provide the correct address at checkout because:`,
      text_13_1: `·If there is incorrect or missing information that we can detect on our end, we may be required to contact you for an update on the delivery information, which can cause delays in delivering your order. `,
      text_13_2: `·We are not responsible if your order gets delivered to the wrong address or returned to sender (as all of the items would be donated right after they come back to our warehouse)
      If you contact the final mile carrier after the order has left our warehouse and ask them to forward or redirect your parcel, we are not responsible if that parcel gets lost, stolen, or damaged.
      Customer service is our #1 priority and we will do whatever we can to take care of you. Thank you for considering printdoors.com and if you have any questions, please don't hesitate to contact us via: support@printdoors.com`
    }
  },
  affiliateProgramApply: {
    text_1: `Affiliate Program`,
    text_2: `Please fill out our application form. We'll review it and let you know via email whether you're approved.`,
    text_3: `Full Name`,
    text_3_1: `please input or select`,
    text_4: `1.What Is Your Identity?`,
    text_4_1: `select`,
    text_4_2: `Beginner-New to affiliate markering`,
    text_4_3: `Intermediate-Basic knowledage,but never earned commission`,
    text_4_4: `Advanced-Some experience,earned some commission`,
    text_4_5: `Expert-Extensive experience and steady income from commissions`,
    text_5: `2.Where Do You Plan To Promote Printdoors?`,
    text_6: `The URLs must be live and publicly accessible`,
    text_7: `My website`,
    text_8: `social media`,
    text_9: `Podcasting or online courses`,
    text_10: `My blog`,
    text_11: `Others`,
    text_12: `3.Primary region`,
    text_13: `Select a region you primarily operate in`,
    text_13_1: `select`,
    text_13_2: `North America`,
    text_13_3: `South America`,
    text_13_4: `Europe`,
    text_13_5: `Asia`,
    text_13_6: `Africa`,
    text_13_7: `Middle East`,
    text_13_8: `Australia & Oceania`,
    text_14: `4.Tell us more about you (optional)`,
    text_15: `Please provide us relevant information about your business or marketing capabilities to help us better evaluate your application`,
    text_16: `I agree to Printdoors affiliate program`,
    text_17: `Terms Of Service`,
    text_18: `Submit`,
    text_19: `I agree to Printdoors affiliate program Terms Of Service is not checked`,
    fail: {
      text_1: `Review progress`,
      text_2: `It's a pity that you didn't pass the audit`,
      text_3: `Reapply`
    },
    checking: {
      text_1: `Review progress`,
      text_2: `Please wait patiently while the audit is being processed`
    },
    dataInfo: {
      text_1: `Data overview`,
      text_2: `Generate promotion link`,
      text_3: `Withdrawable`,
      text_3_1: `Commission to be credited`,
      text_3_2: `Drawing`,
      text_4: `Cumulative income`,
      text_4_1: `Cumulative customers`,
      text_5: `order details`,
      text_5_1: `Statistical time:`,
      text_5_2: `Select customer:`,
      text_5_2_1: `Please select`,
      text_5_3: `Settlement status:`,
      text_5_3_1: `processing`,
      text_5_3_2: `recorded`,
      text_6: `Customer list`,
      text_7: `bill`,
      text_8: `Order_ID`,
      text_9: `Customer`,
      text_10: `purchase`,
      text_11: `commission`,
      text_12: `Payment time`,
      text_13: `Order status`,
      text_14: `Settlement status`,
      text_15: `Promotion time:`,
      text_16: `Select customer:`,
      text_18: `Effective status:`,
      text_19: `Customer
      code`,
      text_20: `Customer
      Name`,
      text_21: `user phone`,
      text_22: `Real name`,
      text_23: `Purchase`,
      text_24: `Estimated
      Commission`,
      text_25: `Commission
      to be recorded`,
      text_26: `Recorded
      Commission`,
      text_27: `Regist time`,
      text_28: `state`,
      text_29: `Transaction type`,
      text_30: `Transaction code`,
      text_31: `money`,
      text_32: `Balance`,
      text_33: `Transaction time`,
      text_34: `state`,
      text_35: `Available:`,
      text_36: `modify`
    },
    withdrawal: {
      text_1: `Withdrawal amount:`,
      text_1_1: `Withdrawal amount is require`,
      text_1_2: `whole`,
      text_1_3: `can't withdraw until you reach $25`,
      text_1_4: `available: $`,
      text_2: `full name:`,
      text_2_1: `full name is require`,
      text_3: `paypal account:`,
      text_3_1: `paypal account is require`,
      text_4: `Submit`
    }
  },
  helpCenter: {
    text_1: `what help do you need`,
    text_2: `how to integrate with bigCommerce`,
    text_3: `Articles`,
    text_4: `results`
  },
  bindStore: {
    text_1: 'Store',
    text_2: 'Find the best integration for your store',
    text_3: `Add New Store`
  }
}
